import type { SetupTourDefinition } from '../core/types';

export const VEHICLE_MODELS_SETUP_TOUR_TARGETS = {
  sidebarVehicleModelsLink: 'fleet-sidebar-vehicle-models-link',
  addModelButton: 'fleet-models-list-add-button',
  modelImageUpload: 'fleet-model-image-upload',
  modelDetailsSection: 'fleet-model-details-section',
  modelTechnicalSection: 'fleet-model-technical-section',
  modelCreateForm: 'fleet-model-create-form',
  modelSubmitButton: 'fleet-model-submit-button',
} as const;

export const vehicleModelsSetupTour: SetupTourDefinition = {
  id: 'vehicle_models_setup',
  label: 'Vehicle Models',
  onboardingKey: 'vehicle_models_setup',
  sidebarTargetsByRoute: {
    '/vehicle-models': VEHICLE_MODELS_SETUP_TOUR_TARGETS.sidebarVehicleModelsLink,
  },
  steps: [
    {
      id: 'sidebar-models',
      route: '/vehicle-models',
      target: VEHICLE_MODELS_SETUP_TOUR_TARGETS.sidebarVehicleModelsLink,
      content: 'Click Vehicle Models in the sidebar to continue setting up your fleet.',
      advanceOnTargetClick: true,
      expandSidebarKeys: ['/fleet'],
    },
    {
      id: 'add-model',
      route: '/vehicle-models',
      target: VEHICLE_MODELS_SETUP_TOUR_TARGETS.addModelButton,
      content: 'Click Add New Vehicle Model to create your first vehicle model.',
      advanceOnTargetClick: true,
    },
    {
      id: 'model-image',
      route: '/vehicle-models/create',
      target: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelImageUpload,
      content: 'Upload an image of the vehicle model to continue.',
      showRequiredFieldsOnEnter: true,
      next: {
        guardTarget: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelImageUpload,
      },
    },
    {
      id: 'model-details',
      route: '/vehicle-models/create',
      target: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelDetailsSection,
      content: 'Select the Vehicle Type, Group, Brand, and Model.',
      showRequiredFieldsOnEnter: true,
    },
    {
      id: 'model-technical',
      route: '/vehicle-models/create',
      target: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelTechnicalSection,
      content:
        'Select the Fuel Type and Gearbox, and enter the Engine CC (unless electric). For cars, also enter the number of Passengers and Doors.',
      showRequiredFieldsOnEnter: true,
    },
    {
      id: 'create-model',
      route: '/vehicle-models/create',
      target: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelSubmitButton,
      content: 'Click Create to save the model and finish Fleet Setup.',
      directNextTargets: [VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelSubmitButton],
      next: {
        label: 'Create',
        guardTarget: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelCreateForm,
        action: {
          type: 'click',
          target: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelSubmitButton,
        },
        waitForTargetRemoval: VEHICLE_MODELS_SETUP_TOUR_TARGETS.modelSubmitButton,
        completesTour: true,
      },
    },
  ],
};
